module.exports = __webpack_public_path__ + "static/media/men_walking.cd6a8d1e.png";